import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ENUMS from '../../../enums';
import { FormattedMessage } from 'react-intl';
import { fileHandlerUrl } from '../../../utils/consts/server';
import { ChevronDownIcon, GlobeIcon } from '~svg';
import './languageSelect.scss';
import { colors } from '../../../utils/consts/color-variable';

const LanguageSelect = ({
  language = { name: 'en', direction: 'ltr' },
  changeLanguage = () => {},
}) => {
  const [isShow, setIsShow] = useState(false);
  const languageRef = useRef(null);
  let route =
    ENUMS?.COUNTRIES_NAMES?.list?.filter(
      (countryName) => countryName.value == language.name,
    )[0].title || 'english';

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (languageRef.current && !languageRef.current.contains(event.target)) {
      setIsShow(false);
    }
  };

  const renderImg = (src = '', alt = 'F') => {
    try {
      return (
        <img
          className="rounded-circle cursor-pointer mx-1 font-msmall text-capitalize bg-white rounded-circle"
          alt={alt}
          src={`${fileHandlerUrl}/icons/flags/${src}.png`}
          width="18"
          height="18"
        />
      );
    } catch (error) {
      return <GlobeIcon size={18} color={colors.dark} />;
    }
  };

  return (
    <div
      ref={languageRef}
      className="d-flex flex-row justify-content-end align-items-center dropdown border border-third default-border-radius-xsmall language-select-container"
    >
      <button
        name="change-language-dropdown"
        id="change-language-dropdown"
        className="btn border-0 px-1 d-flex flex-row justify-content-lg-between justify-content-center align-items-center w-100 default-border-radius-xsmall btn-language"
        onClick={() => setIsShow(!isShow)}
        data-toggle="collapse"
        data-target="#dropdown-lang-card"
        aria-expanded="true"
        aria-controls="dropdown-lang-card"
      >
        <div className="w-100 d-none d-lg-flex align-items-center justify-content-center">
          <span
            className={`d-lg-flex d-none align-items-center justify-content-center transition-all ${
              isShow ? 'rotate-180' : ''
            }`}
          >
            <ChevronDownIcon size={14} color="#343a40" />
          </span>
          <span className="text-dark font-xl-smaller font-xsmall px-1 px-xl-2 d-lg-inline d-none">
            <FormattedMessage id={`language.${route}`} />
          </span>
        </div>
        {renderImg(route)}
      </button>
      {isShow && (
        <ul
          id="dropdown-lang-card"
          className={`flex-column show font-small font-sm-msmall p-0 m-0 position-absolute bg-white border border-third-light list-unstyled default-border-radius-xsmall shadow language-list-container`}
        >
          {ENUMS.COUNTRIES_NAMES.list.map((item, index) => (
            <li
              id={item.title}
              key={`ENUMS-${item.value}`}
              onClick={() => {
                changeLanguage(item.value);
                setIsShow(false);
              }}
              className={`dropdown-item py-2 ${
                index === 0 && 'default-border-top-radius-xsmall'
              } ${
                index === ENUMS.COUNTRIES_NAMES.list.length - 1
                  ? 'default-border-bottom-radius-xsmall'
                  : 'border-bottom'
              } cursor-pointer`}
            >
              {renderImg(item?.title, item?.title?.[0])}
              <span className="px-2 text-primary-dark">
                <FormattedMessage id={`language.${item.title}`} />
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

LanguageSelect.propTypes = {
  language: PropTypes.object,
  changeLanguage: PropTypes.func,
};

export default LanguageSelect;
